import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

class AIChatbotAPIService {
  private _instance: AxiosInstance;
  private _userId: string = 'default_user';

  constructor() {
    const baseUrl: string = window.location.origin + '/editor';
    this._instance = axios.create({
      baseURL: baseUrl,
      // timeout: 30000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    this._setupInterceptors();
  }

  private _setupInterceptors(): void {
    this._instance.interceptors.response.use(
      (response: AxiosResponse) => {
        // 成功时直接返回 AxiosResponse，保持 axios 默认行为
        return response;
      },
      (error: any) => {
        // 记录带上下文的错误
        // 这里尽量不抛出实现细节，保证调用处可统一处理
        // eslint-disable-next-line no-console
        console.error('AIChatbotAPIService 响应错误:', {
          url: error?.config?.url,
          method: error?.config?.method,
          status: error?.response?.status,
          data: error?.response?.data
        });

        const loginRoute: string | undefined = (window as any)?.AGIMX_CONFIG?.lOGIN_ROUTE;
        if (error?.response?.status === 401 && loginRoute) {
          window.location.href = loginRoute;
        }

        return Promise.reject(error);
      }
    );
  }

  private _handleError(error: any, defaultMessage: string): Error {
    if (error?.response?.data?.message) {
      return new Error(error.response.data.message);
    }
    if (error?.message) {
      return new Error(error.message);
    }
    return new Error(defaultMessage);
  }

  public setUserId(userId: string): void {
    this._userId = userId;
  }

  public getUserId(): string {
    return this._userId;
  }

  public async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this._instance.get<T>(url, config);
      // 统一只对外暴露 data，方法签名 Promise<T> 与此一致
      return response.data;
    } catch (error) {
      throw this._handleError(error, '请求失败');
    }
  }

  public async post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this._instance.post<T>(url, data, config);
      return response.data;
    } catch (error) {
      throw this._handleError(error, '请求失败');
    }
  }

  public async patch<T>(url: string, data?: any): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this._instance.patch<T>(url, data);
      return response.data;
    } catch (error) {
      throw this._handleError(error, '请求失败');
    }
  }

  public async delete<T>(url: string): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this._instance.delete<T>(url);
      return response.data;
    } catch (error) {
      throw this._handleError(error, '请求失败');
    }
  }
}

const aiChatbotApiService: AIChatbotAPIService = new AIChatbotAPIService();
export default aiChatbotApiService;
